<script>
    export const slug = 'homePage';
</script>
